interface AdminAccessErrorProps {
  message?: string;
  hint?: string;
  testId?: string;
  loginHref?: string;
  loginLabel?: string;
}

export function AdminAccessError({ message, hint, testId, loginHref, loginLabel }: AdminAccessErrorProps) {
  return (
    <div
      data-testid={testId ?? "admin-access-error"}
      style={{
        minHeight: "100vh",
        background: "#0a0a0a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div style={{ textAlign: "center", padding: "40px 24px", maxWidth: 420 }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>🔒</div>
        <h1 style={{ color: "#fff", fontSize: 20, fontWeight: 700, margin: "0 0 10px" }}>
          Access Denied
        </h1>
        <p style={{ color: "#6b7280", fontSize: 14, margin: 0, lineHeight: 1.65 }}>
          {message ?? "Invalid or expired admin link."}
        </p>
        {hint && (
          <p style={{ color: "#4b5563", fontSize: 12, margin: "10px 0 0", lineHeight: 1.6 }}>
            {hint}
          </p>
        )}
        {loginHref && (
          <a
            href={loginHref}
            data-testid="link-admin-access-error-login"
            style={{
              display: "inline-block",
              marginTop: 24,
              padding: "10px 22px",
              background: "#7c3aed",
              color: "#fff",
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              textDecoration: "none",
              transition: "background 0.15s",
            }}
          >
            {loginLabel ?? "Get a new link →"}
          </a>
        )}
      </div>
    </div>
  );
}
